import { Injectable } from '@angular/core';
import { ShipmentLocationsService, SHIPMENT_LOCATION_TYPE_ID } from '@cemex-core/cmx-api';
import { select, Store } from '@ngrx/store';
import { SetPodsLoader, SetPods } from '../store/actions';
import { Pod } from '../models';
import { GlobalFiltersState } from '../models';
import { selectFilterState } from '../store/selectors';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class GlobalFiltersPodsService {
  constructor(private jobsitesService: ShipmentLocationsService, private store: Store<GlobalFiltersState>) {}

  async getPods(legalEntityId: number, jobsiteId: number) {
    const shouldFetch = await this.shouldFetchPods(legalEntityId, jobsiteId);
    if (!shouldFetch) {
      return;
    }
    try {
      this.store.dispatch(new SetPodsLoader(true));
      const podsResponse = await this.fetchAllPods(legalEntityId, jobsiteId);
      const pods: Pod[] = podsResponse.shipmentLocations.map(pod => {
        return {
          id: pod.shipmentLocationId,
          name: pod.shipmentLocationDesc,
          code: pod.shipmentLocationCode,
        };
      });
      this.store.dispatch(new SetPods(legalEntityId, jobsiteId, pods));
      this.store.dispatch(new SetPodsLoader(false));
    } catch (error) {
      this.store.dispatch(new SetPodsLoader(false));
    }
  }

  private async shouldFetchPods(legalEntityId: number, jobsiteId: number): Promise<boolean> {
    try {
      const filterState = await this.store.pipe(select(selectFilterState), take(1)).toPromise();
      const jobsitePods = filterState.filterPerCustomer[legalEntityId].pods[jobsiteId];
      if (jobsitePods) {
        return false;
      }
      return true;
    } catch (error) {
      return true;
    }
  }

  private fetchAllPods(legalEntityId: number, jobsiteId: number) {
    return this.jobsitesService.getShipmentLocations(this.preparePointOfDeliveryLoadRequest(jobsiteId)).toPromise();
  }

  private preparePointOfDeliveryLoadRequest(selectedJobsiteId: number) {
    return {
      shipmentLocationId: {
        entityId: selectedJobsiteId,
        entityTypeId: SHIPMENT_LOCATION_TYPE_ID.JOBSITE,
      },
      shipmentLocationTypeId: [
        SHIPMENT_LOCATION_TYPE_ID.POINT_OF_DELIVERY,
        SHIPMENT_LOCATION_TYPE_ID.POINT_OF_DELIVERY_REQUEST,
      ].join(','),
    };
  }
}
